export default __webpack_public_path__ + "static/media/lifecycle.406437e0.png";